import React, { useContext } from 'react';
import { LoadingContext } from '../../components/context/LoadingContext';
import Slider from "react-slick";
import i18n from "i18next";
import { Link } from "gatsby"
import iconClock from "../../images/targetVacancies/iconClock.png";

const TargetVacancies = ({workArray}) => {
  const { windowWidth } = useContext(LoadingContext);

  return (
    
              <div className={windowWidth > 1700 ? "desktop:flex desktop:flex-wrap pt-10 gap-auto2" : "desktop:flex desktop:flex-wrap pt-10 gap-auto"}>
                { windowWidth >= 1025 ?
                      <>{ windowWidth >= 1025  && windowWidth <= 1700 ? <>
                      {  workArray.map((job, i) => {
                return (
              <div className={windowWidth > 1700 ? "targetVacancyResponsive":"targetVacancy"} key={job.jobId}>
                <div className='targetWorkTitle'>
                   <p className='ubicationWork' loading="lazy">{job.ubication}</p>

                    <p className='timeWork flex'>
                    <img className='iconClock' src={iconClock} loading="lazy"></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                    <img className='ml-4 iconClock' src={iconClock} loading="lazy"></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                    </p>

                    <img className='mt-4 mb-1' src={job.vacancyImage} alt="Vacancy" loading="lazy"/>

                   <p className='titleWork mt-5' loading="lazy">{job.name}</p>
                   <p className='typeWork mt-2 ' loading="lazy">{i18n.language === "en" ? job.modalityEN : job.modality}</p>
                   </div>

                    <div className='contentDescriptionWork'>
                        <p className='descriptionWork' loading="lazy">
                        {job.description}
                        </p>
                    </div>
                    <Link to={`/open-position/${job.jobId}`}>
                    <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                        <p className='textButtomGetTouch' loading="lazy">{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                    </button>
                    </Link>

                </div>)
                 }) 
                 }
                </>:
                <>
                {  workArray.map((job, i) => {
                    return (
                  <div className='targetVacancyResponsive ' key={job.jobId}>
                    <div className='targetWorkTitle'>
                      <p className='ubicationWork' loading="lazy">{job.ubication}</p>

                      <p className='timeWork flex' >
                      <img className='iconClock' src={iconClock} loading="lazy"></img>
                      {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                      <img className='ml-4 iconClock' src={iconClock} loading="lazy"></img>
                      {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                      </p>

                      <img className='mt-4 mb-1' src={job.vacancyImage} alt="Vacancy" loading="lazy"/>

                      <p className='titleWork mt-5' loading="lazy">{job.name}</p>
                      <p className='typeWork mt-2 ' loading="lazy">{i18n.language === "en" ? job.modalityEN : job.modality}</p>
                      </div>

                        <div className='contentDescriptionWork'>
                            <p className='descriptionWork' loading="lazy">
                            {job.description}
                            </p>
                        </div>
                        <Link to={`/open-position/${job.jobId}`}>
                        <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                            <p className='textButtomGetTouch'>{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                        </button>
                        </Link>

                    </div>)
                    }) 
                    }
                    </>
                }</>:
                      <>
                      {  workArray.map((job, i) => {

                return (
              <div className='targetWorkMobile2 ' key={job.jobId}>
                <div className='targetWorkTitle'>
                   <p className='ubicationWork' loading="lazy">{job.ubication}</p>

                   <p className='timeWork flex'>
                    <img className='iconClock' src={iconClock} loading="lazy"></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                    <img className='ml-4 iconClock' src={iconClock} loading="lazy"></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                    </p>

                    <img className='mt-4 mb-1' src={job.vacancyImage} alt="Vacancy" loading="lazy" />

                   <p className='titleWork mt-5' loading="lazy">{job.name}</p>
                   <p className='typeWork mt-2 ' loading="lazy">{i18n.language === "en" ? job.modalityEN : job.modality}</p>
                   </div>

                    <div className='contentDescriptionWork'>
                        <p className='descriptionWork' loading="lazy">
                        {job.description}
                        </p>
                    </div>
                    <Link to={`/open-position/${job.jobId}`}>
                    <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                        <p className='textButtomGetTouch'>{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                    </button>
                    </Link>

                </div>)
                 }) 
                 }
                      </>
                }
              
              </div>
  );
};

export default TargetVacancies;